import * as React from "react"
import { IconSkeleton, IconProps } from "./skeleton"

export function LayersIcon(props: IconProps) {
  return (
    <IconSkeleton {...props} iconName="CrossIcon" applyColorToStroke={true}>
      <path
        d="M12 2L2 7L12 12L22 7L12 2Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 17L12 22L22 17"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 12L12 17L22 12"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </IconSkeleton>
  )
}
